export const FIRST_LISTEN_KEY = 'storyworld_first_listen_done'
export const ONBOARDED_KEY = 'storyworld_onboarded_v1'
export const CHILD_NAME_KEY = 'storyworld_child_name'
export const CHILD_AGE_KEY = 'storyworld_child_age'
export const CHILD_THEME_KEY = 'storyworld_child_theme'

export function hasCompletedFirstListen() {
  try {
    return localStorage.getItem(FIRST_LISTEN_KEY) === '1'
  } catch {
    return false
  }
}

export function markFirstListenComplete() {
  try {
    localStorage.setItem(FIRST_LISTEN_KEY, '1')
  } catch {
    /* ignore */
  }
}

export function shouldShowUpgradeSurfaces() {
  return hasCompletedFirstListen()
}

export function isOnboarded() {
  try {
    return localStorage.getItem(ONBOARDED_KEY) === '1'
  } catch {
    return false
  }
}

export function markOnboarded() {
  try {
    localStorage.setItem(ONBOARDED_KEY, '1')
  } catch {
    /* ignore */
  }
}

export function getChildContext() {
  try {
    return {
      name: localStorage.getItem(CHILD_NAME_KEY) || '',
      age: localStorage.getItem(CHILD_AGE_KEY) || '',
      theme: localStorage.getItem(CHILD_THEME_KEY) || '',
    }
  } catch {
    return { name: '', age: '', theme: '' }
  }
}

export function setChildContext({ name, age, theme }) {
  try {
    if (name != null) localStorage.setItem(CHILD_NAME_KEY, name)
    if (age != null) localStorage.setItem(CHILD_AGE_KEY, age)
    if (theme != null) localStorage.setItem(CHILD_THEME_KEY, theme)
  } catch {
    /* ignore */
  }
}
